export default "__VITE_ASSET__Ck$yS4re__"